module.exports = __webpack_public_path__ + "static/media/Koffie-Liquid.ad5e12e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/Koffie-Liquid.jpg
// module id = 321
// module chunks = 0